import { useContext } from 'react'
import { typographyStyles } from '@grammarly/badger-ui'
import cn from 'classnames'

import { ExternalLink } from '../ui-lib/link'
import { getConfig } from '../../config'
import { PageContext } from '../../contexts/page-context'

import styles from './breadcrumbs.module.scss'
import { SectionThemeContext } from '../../contexts/section-theme-context'

const baseUrl = getConfig().urls.main

export const Breadcrumbs = () => {
  const { slug: fullPageSlug } = useContext(PageContext)
  const theme = useContext(SectionThemeContext)
  const linkSlugs = fullPageSlug.split('/')

  let cumulativeLinkSlug = ''

  return (
    <nav aria-label="breadcrumbs" className={typographyStyles.C4}>
      <ol className={styles.breadcrumbsList}>
        {linkSlugs.map((slug, index) => {
          cumulativeLinkSlug += `/${slug}`
          const isLastItem = index === linkSlugs.length - 1

          return (
            <>
              <li key={slug} className={styles.breadcrumbItem}>
                <ExternalLink
                  className={cn(
                    styles.breadcrumbItemLink,
                    theme === 'light' && styles.breadcrumbItemLinkLight,
                    theme === 'dark' && styles.breadcrumbItemLinkDark
                  )}
                  aria-current={isLastItem ? 'location' : undefined}
                  href={`${baseUrl}${cumulativeLinkSlug}`}
                >
                  {slug}
                </ExternalLink>
              </li>
              {!isLastItem && (
                <span className={styles.breadcrumbItemSeparator} aria-hidden="true">
                  /
                </span>
              )}
            </>
          )
        })}
      </ol>
    </nav>
  )
}
